import * as React from "react";
import { ConditionLabelModel } from "./ConditionLabelModel";
import styled from "@emotion/styled";
import { Tag } from "antd";

export interface ConditionLabelWidgetProps {
  model: ConditionLabelModel;
}

export const Container = styled.div`
  height: 30px;
  width: 80px;
  pointer-events: all;
`;

export class ConditionLabelWidget extends React.Component<ConditionLabelWidgetProps> {
  render() {
    return (
      <Container>
        <Tag color="blue">{this.props.model.getOptions().label}</Tag>
      </Container>
    );
  }
}
